import React from 'react';

const TvodSlickContext = React.createContext(0);

export default TvodSlickContext;